import './glossaryModule.css'; // Create a CSS file for module-specific styling

export const GlossaryModule = ({ zoomScale }) => {

  return (
    <div className="glossary-module">
        <h2 id="glossary-module-title">Glossaire</h2>
        <ul id="glossary-module-list">
            <li className="glossary-item">
                <p className="glossary definition"><span className="glossary-word">SMAD</span>: Service de média audiovisuel à la demande</p>
            </li>
            <li className="glossary-item">
                <p className="glossary-definition"><span className="glossary-word">EOF</span>: Expression originale française</p>
            </li>
            <li className="glossary-item">
                <p className="glossary-definition"><span className="glossary-word">Accord interprofessionnel</span>: Accord conclu entre un éditeur de service et une ou plusieurs organisations professionnelles de l'industrie cinématographique ou audiovisuelle.</p>
            </li>
            <li className="glossary-item">
                <p className="glossary-definition"><span className="glossary-word">Œuvres patrimoniales</span>: Œuvres de fiction, d'animation, de documentaires de création, y compris de ceux qui sont insérés au sein d'une émission autre qu'un journal télévisé ou une émission de divertissement, de vidéo-musiques et de captation ou de recréation de spectacles vivants.</p>
            </li>
            <li className="glossary-item">
                <p className="glossary-definition"><span className="glossary-word">Pré-achat</span>: Le pré-achat correspond à un achat de droits de diffusion par un diffuseur alors que l'œuvre est encore en production.</p>
            </li>
        </ul>
    </div>
  );
};